import {
  observer,
  useLocation,
  useTranslation,
  Navigate,
  Spin,
  Routes,
  Route,
} from "../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 195, offsets 266253:272628. Structure and names inferred from code, not screenshots.
import * as dependency78493 from "../recovered/style-marker-78493.js";
import * as jsxRuntime from "react/jsx-runtime";
import * as React from "react";
import * as AnnouncementModule from "../components/Announcement.jsx";
import * as GetLanguageModule from "../i18n/getLanguage.js";
import * as AnalyticsContext from "../analytics/AnalyticsProvider.jsx";
import * as UsePageTrackingModule from "../hooks/usePageTracking.js";
import * as LocalizedPathsModule from "./localizedPaths.js";
import * as LocaleContext from "../i18n/I18nProvider.jsx";
import * as ArchivedDocumentsModule from "./archivedDocuments.js";
import h from "../recovered/asset.js";
import { module33577 as f } from "../vendor/dependencies.js";
import * as SiteState from "../state/siteStore.js";
import * as IconModule from "../components/Icon.jsx";
import * as DocumentNavigationModule from "./documentNavigation.js";
import * as PageKindModule from "./pageKind.js";
import * as LanguageToggleModule from "../components/LanguageToggle.jsx";
import * as DocNavItemModule from "../components/DocNavItem.jsx";
import * as DocSearchModule from "../components/DocSearch.jsx";
import * as DocumentEventsModule from "./documentEvents.js";
import * as AgreementPageModule from "./AgreementPage.jsx";
import { loadArchivedChunk, loadArchivedModule } from "../vendor/runtime.js";
dependency78493;
let A = observer(({ isSheet: e = false }) => {
    let { pathname: pathname } = useLocation(),
      { language: language } = (0, LocaleContext.useI18n)(),
      r = (0, React.useRef)(null),
      l = (0, DocumentNavigationModule.f2)(pathname, language),
      s = l?.items ?? [];
    return ((0, React.useLayoutEffect)(() => {
      if (
        (!pathname.startsWith("/docs") && !pathname.startsWith("/test-docs")) ||
        (0, DocumentEventsModule.Z)()
      )
        return;
      let e = (0, DocumentNavigationModule.de)(pathname, language),
        n = r.current;
      if (!e || !n) return;
      let o =
          "u" > typeof CSS && "function" == typeof CSS.escape
            ? CSS.escape(e)
            : e.replaceAll('"', '\\"'),
        a = n.querySelector(`[data-doc-nav-href="${o}"]`);
      a &&
        (function (e, t, i = "smooth") {
          let n = t.getBoundingClientRect().top - e.getBoundingClientRect().top,
            o = e.scrollTop + n;
          e.scrollTo({
            top: Math.max(0, o),
            behavior: i,
          });
        })(n, a, "auto");
    }, [pathname]),
    pathname.startsWith("/docs") || pathname.startsWith("/test-docs")) ? (
      <div
        className={`flex-1 flex flex-col items-start justify-between w-full h-full pt-[16px] pl-[24px] ${(0, PageKindModule.usesPageBackground)(pathname) ? "bg-[var(--color-bg-page)]" : "bg-white"}`}
      >
        <div className={"pb-[12px] w-full"}>
          <DocSearchModule.DocSearch />
        </div>
        <div
          ref={r}
          className={
            "flex flex-col items-start overflow-auto py-0 sticky top-0 w-full flex-1"
          }
        >
          <div className={"flex flex-col gap-px items-start w-full"}>
            {s.map((o) => {
              if ("spacer" in o) return null;
              let { key: key, ...r } = o,
                s = (0, LocalizedPathsModule.Qe)(pathname, language),
                c = l?.href ? `${s}${l.href}` : s,
                d =
                  "agreementFullPath" in r && r.agreementFullPath
                    ? String(r.agreementFullPath).replace(/^\/+/u, "")
                    : "",
                p = r.href ? (d ? `/docs/${d}` : `${c}${r.href}`) : undefined;
              return (
                <DocNavItemModule.DocNavItem
                  key={key}
                  {...r}
                  href={p}
                  level={0}
                  isSheet={e}
                />
              );
            })}
          </div>
        </div>
        <div className={"pb-[18px] w-full"}>
          <LanguageToggleModule.LanguageToggle />
        </div>
      </div>
    ) : null;
  }),
  D = observer(() => {
    let { showBanner: showBanner, docsSidebarCollapsed: docsSidebarCollapsed } =
        SiteState.siteStore,
      { t: translate } = useTranslation(),
      { pathname: pathname } = useLocation(),
      r = 54;
    return (
      (pathname.includes("/docs/") || pathname.includes("/test-docs/")) &&
        (r += 47),
      showBanner && (r += 40),
      (
        <jsxRuntime.Fragment>
          <aside
            className={`sticky top-0 hidden overflow-x-hidden flex-col overflow-y-auto lg:flex shrink-0 min-h-min transition-[width] duration-300 ease-in-out motion-reduce:transition-none ${docsSidebarCollapsed ? "w-0" : "w-[250px]"}`}
            aria-label={"Page navigation"}
            aria-hidden={docsSidebarCollapsed}
            style={{
              height: `calc(100vh - ${r}px)`,
            }}
          >
            <A />
          </aside>
          <f.A title={translate("sidebar.toggle.expand")} placement={"right"}>
            <button
              type={"button"}
              className={
                "absolute hidden lg:flex rounded-[6px] shadow-[0_8px_24px_rgba(0,0,0,0.08)] items-center justify-center top-5 left-[18px] transition-opacity duration-300"
              }
              style={{
                opacity: +!!docsSidebarCollapsed,
                pointerEvents: docsSidebarCollapsed ? "auto" : "none",
              }}
              onClick={() => SiteState.siteStore.toggleDocsSidebarCollapsed()}
            >
              <IconModule.Icon
                icon={"menu-open"}
                size={24}
                style={{
                  padding: "4px",
                }}
              />
            </button>
          </f.A>
        </jsxRuntime.Fragment>
      )
    );
  });
let documentCache = {},
  I = ArchivedDocumentsModule.archivedDocuments.map(
    ({ path: path, importFn: importFn, key: key }) => {
      let Component2;
      return {
        path: path,
        component:
          ((Component2 = (0, React.lazy)(
            () => (
              documentCache[key]?.promise ||
                (documentCache[key] = {
                  ...documentCache[key],
                  promise: importFn().then(
                    (e) => ((documentCache[key].component = e.default), e),
                  ),
                }),
              documentCache[key].promise
            ),
          )),
          function (e) {
            let Component = documentCache[key]?.component;
            return Component ? <Component {...e} /> : <Component2 {...e} />;
          }),
      };
    },
  ),
  P = ["development", "review", "preview", "staging"].includes("production"),
  S = (0, React.lazy)(() =>
    Promise.all([
      loadArchivedChunk(2374),
      loadArchivedChunk(2422),
      loadArchivedChunk(4243),
      loadArchivedChunk(9832),
      loadArchivedChunk(9225),
    ]).then(() => loadArchivedModule(29559)),
  ),
  z = new Set(h);
function L() {
  return (
    <Navigate
      to={(0, LocalizedPathsModule.am)(
        (0, LocalizedPathsModule.Oz)((0, GetLanguageModule.getLanguage)()),
        "welcome",
      )}
      replace={true}
    />
  );
}
function E() {
  let { pathname: pathname, search: search, hash: hash } = useLocation(),
    a = pathname.replace(/^\/docs\/?/u, "").replace(/\/$/u, "");
  if (!a) return <L />;
  if ("chrome-plugin" === a || a.startsWith("chrome-plugin/"))
    return (
      <Navigate to={`/docs/chrome-plugin${search}${hash}`} replace={true} />
    );
  if (a.startsWith("zh-CN/")) {
    let e = a.slice(6);
    if (e && z.has(e))
      return <Navigate to={`/docs/${e}${search}${hash}`} replace={true} />;
  }
  if (a.startsWith("en-US/")) {
    let e = a.slice(6);
    if (e && z.has(e))
      return <Navigate to={`/docs/${e}${search}${hash}`} replace={true} />;
  }
  for (let e of ["zh-CN", "en-US"])
    if (a === e || a.startsWith(`${e}/`)) {
      let r = a === e ? "" : a.slice(e.length + 1);
      if (r) {
        let a = (0, DocumentNavigationModule.UI)(r);
        if (a)
          return (
            <Navigate to={`/docs/${e}${a}${search}${hash}`} replace={true} />
          );
      }
      return (
        <Navigate to={`/docs/${e}/welcome${search}${hash}`} replace={true} />
      );
    }
  {
    let e = (0, DocumentNavigationModule.UI)(a);
    if (e) {
      let a = (0, LocalizedPathsModule.Oz)(
        (0, GetLanguageModule.getLanguage)(),
      );
      return <Navigate to={`/docs/${a}${e}${search}${hash}`} replace={true} />;
    }
  }
  let r = (0, LocalizedPathsModule.Oz)((0, GetLanguageModule.getLanguage)());
  return <Navigate to={`/docs/${r}/${a}${search}${hash}`} replace={true} />;
}
function DocumentRoutes() {
  let e = useLocation(),
    { language: language, setLanguage: setLanguage } = (0,
    LocaleContext.useI18n)(),
    { track: track } = (0, AnalyticsContext.useAnalytics)();
  return (
    (0, UsePageTrackingModule.usePageTracking)(
      track,
      "docs_view",
      () => ({
        doc_page: e.pathname,
      }),
      {
        reportOnUnmount: true,
        reportOnBeforeUnload: true,
      },
    ),
    (0, React.useEffect)(() => {
      let n = (0, LocalizedPathsModule.EH)(e.pathname);
      if (null != n) {
        if (n !== language) return void setLanguage(n);
        try {
          localStorage.getItem("user_language_preference") !== n &&
            localStorage.setItem("user_language_preference", n);
        } catch {}
      }
    }, [e.pathname, language, setLanguage]),
    (0, React.useEffect)(() => {
      let e = document.querySelector("main");
      e &&
        e.scrollTo({
          top: 0,
          behavior: "auto",
        });
    }, [e.pathname]),
    (0, React.useEffect)(() => {
      let e = async () => {
        for (
          let e = 0;
          e < ArchivedDocumentsModule.archivedDocuments.length;
          e += 5
        ) {
          let t = ArchivedDocumentsModule.archivedDocuments.slice(e, e + 5);
          (await Promise.allSettled(
            t.map(
              ({ importFn: importFn, key: key }) => (
                documentCache[key]?.promise ||
                  (documentCache[key] = {
                    promise: importFn().then(
                      (e) => ((documentCache[key].component = e.default), e),
                    ),
                  }),
                documentCache[key].promise
              ),
            ),
          ),
            await new Promise((e) => {
              setTimeout(e, 100);
            }));
        }
      };
      "requestIdleCallback" in window
        ? window.requestIdleCallback(() => {
            setTimeout(e, 500);
          })
        : setTimeout(e, 2e3);
    }, []),
    (
      <jsxRuntime.Fragment>
        <AnnouncementModule.Announcement />
        <div
          className={
            "relative flex flex-1 flex-shrink-0 items-start flex-start w-full max-w-[1440px] mx-auto"
          }
        >
          {!e.pathname.includes("chrome-plugin") && <D />}
          <React.Suspense
            fallback={
              <div className={"flex-1 flex justify-center pt-20"}>
                <Spin spinning={true} />
              </div>
            }
          >
            <Routes>
              <Route index={true} element={<L />} />
              {P && <Route path={"chrome-plugin"} element={<S />} />}
              {I.map(({ path: path, component: component }) => (
                <Route key={path} path={path} element={<component />} />
              ))}
              {ArchivedDocumentsModule.vg.flatMap((e) => [
                <Route
                  key={`z-${e.fromPrefix}`}
                  path={`zh-CN/${e.fromPrefix}/*`}
                  element={
                    <AgreementPageModule.AgreementPage
                      fromPrefix={e.fromPrefix}
                      toPrefix={e.toPrefix}
                    />
                  }
                />,
                <Route
                  key={`e-${e.fromPrefix}`}
                  path={`en-US/${e.fromPrefix}/*`}
                  element={
                    <AgreementPageModule.AgreementPage
                      fromPrefix={e.fromPrefix}
                      toPrefix={e.toPrefix}
                    />
                  }
                />,
                <Route
                  key={`u-${e.fromPrefix}`}
                  path={`${e.fromPrefix}/*`}
                  element={
                    <AgreementPageModule.AgreementPage
                      fromPrefix={e.fromPrefix}
                      toPrefix={e.toPrefix}
                    />
                  }
                />,
              ])}
              <Route path={"*"} element={<E />} />
            </Routes>
          </React.Suspense>
        </div>
      </jsxRuntime.Fragment>
    )
  );
}
export { documentCache, DocumentRoutes };
